import { guideItems } from "@/mocks/loveHelperData";

export default function GuideSection() {
  return (
    <section id="guide" className="mx-auto max-w-7xl px-4 py-16 md:py-20 md:px-6">
      <div className="text-center">
        <span className="text-sm font-semibold text-primary-600">追漫指南</span>
        <h2 className="mt-2 text-2xl font-bold text-foreground-900 md:text-4xl">
          一站式追漫攻略
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
          从新手入坑到伏笔考据、人气CP排行，我们把最有用的内容整理成一篇篇专题，帮你轻松上手这部作品。
        </p>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {guideItems.map((g) => (
          <article
            key={g.id}
            className="group rounded-lg border border-background-200 bg-background-50 p-6 transition-all hover:-translate-y-1 hover:border-accent-300"
          >
            <div className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-100 text-xl text-accent-600">
              <i className={g.icon}></i>
            </div>
            <span className="mt-4 inline-block rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
              {g.tag}
            </span>
            <h3 className="mt-2 text-lg font-bold text-foreground-900">{g.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">{g.desc}</p>
            <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-600">
              查看详情 <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
            </span>
          </article>
        ))}
      </div>
    </section>
  );
}